import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { getCurrentUser } from 'features/auth/ducks/selectors'
import CloseIcon from '@mui/icons-material/Close'
import { hideEmail } from 'utils/user'
import { formatDay } from './remedialDates'
import { INK } from './ui'

export const involvesLabel = (name, isYou = false) => {
  if (isYou) return 'Only remedials involving you'
  const clean = typeof name === 'string' ? name.trim() : ''
  return `Only remedials involving ${clean ? hideEmail(clean) : 'the person you chose'}`
}

export const resolvedLabel = (from, to) => {
  if (from && to) return `Resolved between ${formatDay(from)} and ${formatDay(to)}`
  if (from) return `Resolved from ${formatDay(from)}`
  if (to) return `Resolved up to ${formatDay(to)}`
  return ''
}

export const InvolvesChip = ({ filters, onChange }) => {
  const currentUser = useSelector(getCurrentUser)
  if (!filters.involves) return null
  const isYou = !!currentUser?.id && currentUser.id === filters.involves
  return (
    <Chip title='Remedials this person owns, or where they are assigned to one of the tasks'>
      {involvesLabel(filters.involvesName, isYou)}
      <ChipClear type='button' onClick={() => onChange({ involves: null, involvesName: null })} aria-label='Show remedials for everyone'>
        <CloseIcon style={{ fontSize: 18 }} aria-hidden='true' />
      </ChipClear>
    </Chip>
  )
}

export const ResolvedChip = ({ filters, onChange }) => {
  if (!filters.resolvedFrom && !filters.resolvedTo) return null
  return (
    <Chip title='Only remedials resolved on these dates'>
      {resolvedLabel(filters.resolvedFrom, filters.resolvedTo)}
      <ChipClear type='button' onClick={() => onChange({ resolvedFrom: null, resolvedTo: null })} aria-label='Show remedials resolved on any date'>
        <CloseIcon style={{ fontSize: 18 }} aria-hidden='true' />
      </ChipClear>
    </Chip>
  )
}

export const raisedLabel = (from, to) => {
  if (from && to) return `Raised between ${formatDay(from)} and ${formatDay(to)}`
  if (from) return `Raised from ${formatDay(from)}`
  if (to) return `Raised up to ${formatDay(to)}`
  return ''
}

export const RaisedChip = ({ filters, onChange }) => {
  if (!filters.raisedFrom && !filters.raisedTo) return null
  return (
    <Chip title='Only remedials raised on these dates'>
      {raisedLabel(filters.raisedFrom, filters.raisedTo)}
      <ChipClear type='button' onClick={() => onChange({ raisedFrom: null, raisedTo: null })} aria-label='Show remedials raised on any date'>
        <CloseIcon style={{ fontSize: 18 }} aria-hidden='true' />
      </ChipClear>
    </Chip>
  )
}

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  max-width: 100%;
  padding: 0 4px 0 12px;
  border-radius: 20px;
  background: #f4f4f5;
  font-size: 14px;
  color: ${INK};
  overflow-wrap: anywhere;
`

const ChipClear = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border: none;
  background: none;
  cursor: pointer;
  &:focus-visible { outline: 2px solid ${INK}; outline-offset: 2px; border-radius: 20px; }
`
